import type { CurrencyCode } from "../models/currency";
import type {
  PortfolioDetail,
  PortfolioEditModel,
  PortfolioListItem,
  PortfolioSummary,
  ValueHistoryPoint,
  ValueHistoryRange,
} from "../models/portfolio";
import type { AllocationGrouping, AllocationSlice, Position, PositionPeriodProfitLoss } from "../models/position";
import type { RealizedLot } from "../models/realized-lot";
import { portfoliosClient } from "./api-clients";

export const portfoliosApi = {
  getPortfolios(includeArchived: boolean, signal?: AbortSignal): Promise<PortfolioListItem[]> {
    return portfoliosClient.getPortfolios(includeArchived, signal);
  },
  getPortfolio(portfolioId: number, signal?: AbortSignal): Promise<PortfolioDetail> {
    return portfoliosClient.getPortfolio(portfolioId, signal);
  },
  getSummary(portfolioId: number, currency: CurrencyCode, signal?: AbortSignal): Promise<PortfolioSummary> {
    return portfoliosClient.getSummary(portfolioId, currency, signal);
  },
  getPositions(portfolioId: number, currency: CurrencyCode, signal?: AbortSignal): Promise<Position[]> {
    return portfoliosClient.getPositions(portfolioId, currency, signal);
  },
  getPositionsPeriodProfitLoss(
    portfolioId: number,
    range: ValueHistoryRange,
    currency: CurrencyCode,
    signal?: AbortSignal,
  ): Promise<PositionPeriodProfitLoss[]> {
    return portfoliosClient.getPositionsPeriodProfitLoss(portfolioId, range, currency, signal);
  },
  getHistory(portfolioId: number, range: ValueHistoryRange, currency: CurrencyCode, signal?: AbortSignal): Promise<ValueHistoryPoint[]> {
    return portfoliosClient.getHistory(portfolioId, range, currency, signal);
  },
  getAllocation(portfolioId: number, grouping: AllocationGrouping, signal?: AbortSignal): Promise<AllocationSlice[]> {
    return portfoliosClient.getAllocation(portfolioId, grouping, signal);
  },
  getRealizedLots(portfolioId: number, signal?: AbortSignal): Promise<RealizedLot[]> {
    return portfoliosClient.getRealizedLots(portfolioId, signal);
  },
  createPortfolio(model: PortfolioEditModel): Promise<PortfolioListItem> {
    return portfoliosClient.createPortfolio(model);
  },
  updatePortfolio(portfolioId: number, model: PortfolioEditModel): Promise<PortfolioListItem> {
    return portfoliosClient.updatePortfolio(portfolioId, model);
  },
  archivePortfolio(portfolioId: number): Promise<void> {
    return portfoliosClient.archivePortfolio(portfolioId);
  },
};
